let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cBrt7")).then(() => parcelRequire('kqMbh'));